import _ from 'lodash';

export const filterByAppName = (apps, key) => _.filter(apps, (app) => app.name.toLowerCase().includes(key.toLowerCase()));



// WEBPACK FOOTER //
// ./src/utils/filters.js